module.exports = __webpack_public_path__ + "static/02-54ffddb205d37d70bc6fe9301661daca.png";